import * as React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import './AssetsStepperComp.css';
import AssetCategoryComp from './AssetCategoryComp.js';

import {
  Stack,
  Stepper,
  Step,
  StepLabel,
  StepConnector,
  Typography,
  Fab,
} from '@mui/material';
import { stepConnectorClasses } from '@mui/material/StepConnector';
import {
  ArrowBackIos as ArrowBackIosIcon,
  ArrowForwardIos as ArrowForwardIosIcon,
  Check as CheckIcon,
  Filter1 as Filter1Icon,
  Filter2 as Filter2Icon,
  Filter3 as Filter3Icon,
  Filter4 as Filter4Icon,
  Filter5 as Filter5Icon,
} from '@mui/icons-material';
import AddAsset1 from './AddAsset1.js';
import AddAsset2 from './AddAsset2.js';
import AddAsset3 from './AddAsset3.js';
import AddAsset4 from './AddAsset4.js';
import AddAsset2Point5 from './AddAsset2Point5.js';
import Header from "./Header";
import Footer from "./Footer";
// import SearchCategoryComp from './SearchCategoryComp.js';
import AOS from "aos";
import "aos/dist/aos.css";

const QontoStepIconRoot = styled('div')(({ theme, ownerState }) => ({
  color: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#eaeaf0',
  display: 'flex',
  height: 22,
  alignItems: 'center',
  ...(ownerState.active && {
    color: '#784af4',
  }),
  '& .QontoStepIcon-completedIcon': {
    color: '#784af4',
    zIndex: 1,
    fontSize: 18,
  },
  '& .QontoStepIcon-circle': {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
  },
}));

function QontoStepIcon(props) {
  const { active, completed, className } = props;

  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      {completed ? (
        <CheckIcon className='QontoStepIcon-completedIcon' />
      ) : (
        <div className='QontoStepIcon-circle' />
      )}
    </QontoStepIconRoot>
  );
}

QontoStepIcon.propTypes = {
  /**
   * Whether this step is active.
   * @default false
   */
  active: PropTypes.bool,
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: PropTypes.bool,
};

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        'linear-gradient( 95deg,rgb(0,30,0) 0%,rgb(0,0,87) 50%,rgb(0,0,135) 100%)',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
      'linear-gradient( 95deg,rgb(0,30,0) 0%,rgb(0,0,87) 50%,rgb(0,0,135) 100%)',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor:
      theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
    borderRadius: 1,
  },
}));

const ColorlibStepIconRoot = styled('div')(({ theme, ownerState }) => ({
  backgroundColor:
    theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#ccc',
  zIndex: 1,
  color: '#fff',
  width: 50,
  height: 50,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  ...(ownerState.active && {
    backgroundImage:
    'linear-gradient( 95deg,rgb(0,30,0) 0%,rgb(0,0,87) 50%,rgb(0,0,135) 100%)',
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
  }),
  ...(ownerState.completed && {
    backgroundImage:
    'linear-gradient( 95deg,rgb(0,30,0) 0%,rgb(0,0,87) 50%,rgb(0,0,135) 100%)',
  }),
}));

function ColorlibStepIcon(props) {
  const { active, completed, className } = props;

  const icons = {
    1: <Filter1Icon  style={{background:'',color:'#fff'}}/>,
    2: <Filter2Icon  style={{background:''}}/>,
    3: <Filter3Icon style={{background:''}} />,
    4: <Filter4Icon style={{background:''}} />,
    5: <Filter5Icon style={{background:''}} />,
  };

  return (
    <ColorlibStepIconRoot
      ownerState={{ completed, active }}
      className={className} style={{background:(completed || active) ? 'darkblue' : 'lightgray'}}>
      {icons[String(props.icon)]}
    </ColorlibStepIconRoot>
  );
}

ColorlibStepIcon.propTypes = {
  /**
   * Whether this step is active.
   * @default false
   */
  active: PropTypes.bool,
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: PropTypes.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node,
};

const steps = [
  'Boat Specifications',
  'Boat Specifications Details',
  'Listing Title & description',
  'Pricing and Availability',
  'Commercial Charter Insurance Document Upload',
];

export default function AssetsStepperComp({setType}) {
  const [order, setOrder] = React.useState(0);
  const [windowWidth, setWindowWidth] = React.useState(window.outerWidth);
  var [catType,setCatType] = React.useState('Yachts');
  var [type,setType] = React.useState('')

  window.addEventListener('resize',function (){
    setWindowWidth(window.outerWidth)
    console.log(windowWidth)
  })

  const handlePrevious = () => {
    setOrder((prev) => prev - 1);
  };

  const handleNext = () => {
    setOrder((prev) => prev + 1);
  };

  return (
  <div className='assetsParent'> 


<Typography
      data-aos="zoom-in"
      data-aos-duration="1000"
      data-aos-easing="ease-in-out"
      variant='h3' color='primary' sx={{ textAlign: 'center', color:'black' }}
      // style={{display: windowWidth>540 ? 'block' : 'none'}}
      >
        List An Asset
      </Typography>
<div className='assetCatCompParentMain'>
<AssetCategoryComp  type={type} setType={setType} />
</div>

    <div className='AssetsStepperCompMain'>
      

      {/* <br /> */}

            {/* <Header /> */}
            {/* <div className='SearchCategoryCompMain2' onClick={()=>setType('')}>
            <button className={catType=='Yachts' ? 'selected2 first2' : 'notSelected2 first2'}
            onClick={()=>setCatType('Yachts')}>
                Yachts
            </button>
            <button className={catType=='Cars' ? 'selected2' : 'notSelected2'}
            onClick={()=>setCatType('Cars')}>
                Cars
            </button>
            <button className={catType=='Helicopters' ? 'selected2' : 'notSelected2'}
            onClick={()=>setCatType('Helicopters')}>
            Helicopters
            </button>
            <button className={catType=='Homes' ? 'selected2' : 'notSelected2'}
            onClick={()=>setCatType('Homes')}>
            Homes/Villas
            </button>
            <button className={catType=='Airplanes' ? 'selected2' : 'notSelected2'}
            onClick={()=>setCatType('Airplanes')}>
            Airplanes
            </button>
        </div> */}

      <br />
      <Stack sx={{ width: windowWidth>540 ? '100%' : '25%' }} spacing={4}>
        <Stepper
          alternativeLabel
          style={{maxWidth:'100%' , flexDirection:windowWidth>540 ? 'row' : 'column'}}
          activeStep={order}
          connector={<ColorlibConnector />}
          >
          {steps.map((label, index) => (
            <Step key={index}>
              <StepLabel  StepIconComponent={ColorlibStepIcon}>
                {label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </Stack>
      {order === 0 ? (
        <AddAsset1 order={order} handlePrevious={handlePrevious} handleNext={handleNext} />
      ) : order === 1 ? (
        <AddAsset2 order={order} handlePrevious={handlePrevious} handleNext={handleNext} />
      ) : order === 2 ? (
        <AddAsset2Point5 order={order} handlePrevious={handlePrevious} handleNext={handleNext} />
      ) : order === 3 ? (
        <AddAsset3 order={order} handlePrevious={handlePrevious} handleNext={handleNext} />
      ) : (
        <AddAsset4 order={order} handlePrevious={handlePrevious} handleNext={handleNext} />
      )
      }
      <br />
      <br />
      <br />
      <br />

      <br />
      {/* <Footer /> */}

    </div>
    </div>
  );
}
